import React from "react";
import { Box, Button, Divider, Paper, Typography, Link } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { TabHeader } from "../../components/profile/accountInformation/TabHeader";
import { SectionHeader } from "../../components/profile/subscription/SectionHeader";
import { InfoSection } from "../../components/profile/subscription/InfoSection";
import { formatedDateIST } from "../../utils/utils";
import { CREATE_UPDATE_BUTTON } from "../../styles/ButtonStyles";
import { StatusSection } from "../../components/profile/subscription/StatusSection";
import { INDIAN_RUPEE_SIGN } from "../../constant/constant";

export const SubscriptionDetails = ({ planDetails }) => {
  return (
    <>
      {/* Header */}
      <TabHeader
        title="Subscription"
        breadcrumb="Profile - Subscription Details"
        IconComponent={HomeIcon}
      />

      {/* Personal Information */}
      <Box sx={{ width: "100%", p: 1, mt: 2 }}>
        <Paper
          elevation={2}
          sx={{ width: "100%", borderRadius: 2, backgroundColor: "#fff" }}
        >
          <SectionHeader
            title={planDetails.plan_name}
            description={planDetails.plan_description}
          />
          <Divider />

          <StatusSection
            label="Status"
            value={planDetails.is_active}
            text="Active"
          />
          <InfoSection
            label="Expiration Date"
            value={formatedDateIST(planDetails.end_date)}
          />
          <InfoSection
            label="Renewal Price (including tax)"
            value={`${INDIAN_RUPEE_SIGN} ${planDetails.renewal_price}`}
          />
          <InfoSection label="Subscription ID" value={planDetails.plan_id} />
          <StatusSection
            label="Auto-renewal"
            value={planDetails.auto_renewal}
            text="On"
          />
          <InfoSection
            label="Next Billing Date"
            value={formatedDateIST(planDetails.next_billing_date)}
          />
        </Paper>

        <Typography variant="body2" sx={{ p: 2 }}>
          Need more resource? <Link href="#">Upgrade to a higher plan</Link>
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Button variant="outlined">Disable auto-renewal</Button>
          <Button sx={CREATE_UPDATE_BUTTON}>Renew</Button>
        </Box>
      </Box>
    </>
  );
};
